export { negociacaoAssinaturasReducer } from './slice';
